/*
 * action types
 */
export default {
  CHECK_REQUEST_QUEUE: "CHECK_REQUEST_QUEUE",
  INVALIDATE_ACCESSTOKEN: "INVALIDATE_ACCESSTOKEN",

  // SESSION
  GET_ACCESSTOKEN_PENDING: "GET_ACCESSTOKEN_PENDING",
  GET_ACCESSTOKEN_SUCCESS: "GET_ACCESSTOKEN_SUCCESS",
  GET_ACCESSTOKEN_ERROR: "GET_ACCESSTOKEN_ERROR",

  SET_WECAREID: "SET_WECAREID",

  // APPOINTMENTS
  CLEAN_APPOINTMENTS: "CLEAN_APPOINTMENTS",

  GET_APPOINTMENTS_PENDING: "GET_APPOINTMENTS_PENDING",
  GET_APPOINTMENTS_SUCCESS: "GET_APPOINTMENTS_SUCCESS",
  GET_APPOINTMENTS_ERROR: "GET_APPOINTMENTS_ERROR",

  GET_NEXT_APPOINTMENTS_PENDING: "GET_NEXT_APPOINTMENTS_PENDING",
  GET_NEXT_APPOINTMENTS_SUCCESS: "GET_NEXT_APPOINTMENTS_SUCCESS",
  GET_NEXT_APPOINTMENTS_ERROR: "GET_NEXT_APPOINTMENTS_ERROR",

  POST_UPDATE_APPOINTMENTS_PENDING: "POST_UPDATE_APPOINTMENTS_PENDING",
  POST_UPDATE_APPOINTMENTS_SUCCESS: "POST_UPDATE_APPOINTMENTS_SUCCESS",
  POST_UPDATE_APPOINTMENTS_ERROR: "POST_UPDATE_APPOINTMENTS_ERROR",

  // SEND RESET CODE
  GET_RESETCODE_PENDING: "GET_RESETCODE_PENDING",
  GET_RESETCODE_SUCCESS: "GET_RESETCODE_SUCCESS",
  GET_RESETCODE_ERROR: "GET_RESETCODE_ERROR",

  // CGN
  CLEAN_CGN: "CLEAN_CGN",

  GET_CGN_PENDING: "GET_CGN_PENDING",
  GET_CGN_SUCCESS: "GET_CGN_SUCCESS",
  GET_CGN_ERROR: "GET_CGN_ERROR",

  COMPONENT_QUIZZ_CGN_PENDING: "COMPONENT_QUIZZ_CGN_PENDING",
  COMPONENT_QUIZZ_CGN_SUCCESS: "COMPONENT_QUIZZ_CGN_SUCCESS",
  COMPONENT_QUIZZ_CGN_ERROR: "COMPONENT_QUIZZ_CGN_ERROR",

  POST_UPDATE_CGN_PENDING: "POST_UPDATE_CGN_PENDING",
  POST_UPDATE_CGN_SUCCESS: "POST_UPDATE_CGN_SUCCESS",
  POST_UPDATE_CGN_ERROR: "POST_UPDATE_CGN_ERROR",

  // GET PENDING CPE
  GET_PENDING_CPE_PENDING: "GET_PENDING_CPE_PENDING",
  GET_PENDING_CPE_SUCCESS: "GET_PENDING_CPE_SUCCESS",
  GET_PENDING_CPE_ERROR: "GET_PENDING_CPE_ERROR",

  // ACTIVATE CPE
  POST_ACTIVATE_CPE_PENDING: "POST_ACTIVATE_CPE_PENDING",
  POST_ACTIVATE_CPE_SUCCESS: "POST_ACTIVATE_CPE_SUCCESS",
  POST_ACTIVATE_CPE_ERROR: "POST_ACTIVATE_CPE_ERROR",

  // STATUS CPE
  POST_STATUS_CPE_PENDING: "POST_STATUS_CPE_PENDING",
  POST_STATUS_CPE_SUCCESS: "POST_STATUS_CPE_SUCCESS",
  POST_STATUS_CPE_ERROR: "POST_STATUS_CPE_ERROR",

  SET_USER_MATERIALS: "SET_USER_MATERIALS",

  // UI
  OPEN_MODAL: "OPEN_MODAL",
  CLOSE_MODAL: "CLOSE_MODAL",
};



// WEBPACK FOOTER //
// ./src/consts/actionTypes.js